import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import { ProfilePatientRecordContainer } from 'app/containers/DentalTreatmentManagement/ProfilePatientRecord'

const ProfilePatientRecordPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.add_patient_record)}</PageTitle>
      <ProfilePatientRecordContainer />
    </>
  )
}
const ProfilePatientRecordPage = memo(ProfilePatientRecordPageCpn, isEqual)

export default ProfilePatientRecordPage
